import angular from 'angular';


const contextProvider = angular.module('ttb.services.context.provider', [])
  .provider('context', () => ({
    $get: ['$q', '$http', ($q, $http) => {
      const getProject = () => $q.resolve({
        group: ttb.constants.routing.PROJECT_GROUP,
        name: ttb.constants.routing.PROJECT_NAME,
      });


      const getAssignUserToTeamTemplate = ({ teamId }) => $q((resolve, reject) => {
        $http.get(`${url}/assing-user-to-team-template`, { params: { teamId } })
          .then((response) => {
            if (DEBUG) {
              console.log(response);
            }
            resolve(response.data);
          }, reject);
      });

      const getlicense = (companyId) => $q((resolve, reject) => {
        $http.get('system/getlicense', { params: { companyId: companyId } })
        .then((response) => {
          if (DEBUG) {
            console.log(response);
          }
          resolve(response.data);
        }, reject);
      });

        return {
        getProject,
        getlicense,
      };
    }],
  }))
  .name;

export default contextProvider;



// WEBPACK FOOTER //
// ../services/context.provider.js